import React from "react";
import { Trash2 } from "lucide-react";

type ConfirmDeleteDialogProps = {
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
};

export const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
    message,
    onConfirm,
    onCancel,
}) => {
    return (
        <dialog id="confirm_delete_dialog" className="modal">
            <form method="dialog" className="modal-box">
                <div className="flex items-center gap-2 mb-4">
                    <Trash2 className="text-red-500" />
                    <h3 className="font-bold text-lg">Confirm Deletion</h3>
                </div>
                <p>{message}</p>
                <div className="modal-action">
                    <button
                        className="btn"
                        onClick={(e) => {
                            e.preventDefault();
                            onCancel();
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-error"
                        onClick={(e) => {
                            e.preventDefault();
                            onConfirm();
                        }}
                    >
                        Confirm
                    </button>

                </div>
            </form>
        </dialog>
    );
};